<template>
  <div class="Feedback-type-main" :class="{ 'Feedback-type-main-mobile': isMobile }">
    <div class="headers">
      <div class="headers-title">尊敬的用户：</div>
      如果您在使用我们产品和服务的过程中，遇到任何与数据安全或个人隐私相关的问题，可以选择如下方式与贝壳隐私合规团队联系：
    </div>
    <div class="main">
      <div
        class="Feedback-type-item-main"
        :class="{ 'Feedback-type-item-main-mobile': isMobile }"
      >
        <div class="title">方式一：通过提交问卷与我们联系</div>
        <div class="content">
          您可以将您要反馈的隐私或个人信息相关的问题，通过<span
            class="questionnaire"
            @click="questionnaire"
            >“填写问卷”</span
          >的形式与我们联系，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以反馈。
        </div>
      </div>
      <div
        class="Feedback-type-item-main"
        :class="{ 'Feedback-type-item-main-mobile': isMobile }"
      >
        <div class="title">方式二：通过邮箱与我们联系</div>
        <div class="content">
          您也可以选择将问题发送至kefu@ke.com，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以反馈。
        </div>
      </div>
      <!-- <FeedbackTypeItem v-for="item in dataList" :key="item.id" :data="item"></FeedbackTypeItem> -->
    </div>
    <AuthenTication></AuthenTication>
  </div>
</template>
<script>
export default {
  name: "FeedbackType",
  data() {
    return {
      dataList: [
        {
          title: "方式一：通过提交问卷与我们联系",
          content:
            "您可以将您要反馈的隐私或个人信息相关的问题，通过“填写问卷”的形式与我们联系，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以反馈。",
          id: 1,
          bgImage: require("@/assets/images/privacyManage/mode-title.png"),
        },
        {
          title: "方式二：通过邮箱与我们联系",
          content:
            "您也可以选择将问题发送至123@beike.com，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以反馈。",
          id: 2,
          bgImage: require("@/assets/images/privacyManage/mode-title.png"),
        },
      ],
    };
  },
  methods: {
    questionnaire() {
      if (isMobile) {
        this.$router.push("/verification");
      }
      this.$store.commit("app/CHANGE_STATUS", true);
    },
  },
};
</script>
<style lang="scss" scoped>
.Feedback-type-main {
  margin-top: calc($multiple * 50px);
  width: calc($multiple * 1040px);
}
.headers {
  /* height: 72px * $multiple; */
  font-size: calc($multiple * 16px);
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #000000;
  line-height: calc($multiple * 36px);
  letter-spacing: 1px;
  .headers-title {
    font-size: calc($multiple * 20px);
    color: #8b8b8b;
  }
}
.main {
  width: 100%;
  margin-top: calc($multiple * 43px);
  display: flex;
  justify-content: space-around;
}
.Feedback-type-item-main {
  border-radius: 2px;
  width: calc($multiple * 507px);
  height: calc($multiple * 250px);
  background: #fff;
  box-shadow: 0 2px 12px 2px rgba(226, 226, 226, 0.59);
  .questionnaire {
    color: rgb(83, 83, 211);
    cursor: pointer;
  }
}
.title {
  width: 100%;
  height: calc($multiple * 90px);
  background-repeat: no-repeat;
  background-size: cover;
  font-size: calc($multiple * 16px);
  font-family: PingFangTC-Medium, PingFangTC;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* border-radius: 0.03rem 0.03rem 0 0; */
  background-image: url(@/assets/images/privacyManage/mode-title.png);
}
.content {
  font-size: calc($multiple * 14px);
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: #000000;
  line-height: calc($multiple * 37px);
  letter-spacing: 1px;
  padding: calc($multiple * 22px) calc($multiple * 33px) 0 calc($multiple * 27px);
}
.Feedback-type-item-main-mobile {
  width: auto;
  margin: 1.02rem 0 0;
  border-radius: 0.1rem;
  width: 17.15rem;
  height: auto;
  box-shadow: 0px 10px 61px 10px rgba(226, 226, 226, 0.59);
  .title {
    width: 100%;
    height: 4.04rem;
    background-size: 105% 115%;
    background-position: -0.4rem -0.4rem;
    font-size: 0.82rem;
    line-height: 4.04rem;
    letter-spacing: 0.05rem;
    padding-left: 1.18rem;
  }
  .content {
    font-size: 0.72rem;
    line-height: 1.59rem;
    padding: 1rem 0.8rem 1.02rem;
    text-align: justify;
    color: #4a4a4a;
  }
}
.Feedback-type-main-mobile {
  width: auto;
  margin-top: 1.23rem;
  .headers {
    width: 17.15rem;
    height: auto;
    font-size: 0.61rem;
    line-height: 0.98rem;
    letter-spacing: 0.05rem;
    color: #8b8b8b;
    .headers-title {
      font-size: 0.8rem;
      color: #000000;
    }
  }
  .main {
    margin-top: 0.21rem;
    flex-direction: column;
  }
}
</style>
